import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import withData from 'util/hoc/with-data';
import Query from 'apps/admin/util/query';
import Loading from 'components/loading';
import CheckedSvg from 'library/icons/check.svg';
import Confirm from 'library/helpers/confirm';
import Notification, { Error as NotificationError } from 'library/components/notification';
import { Switch, Route, MemoryRouter, Link } from 'react-router-dom';
import SurveyConnector from 'apps/admin/components/survey-connector';
import { withRouter } from 'react-router';

const ConvertedDate = (d) => {
  const _d = new Date(d);

  return _d.toString();
};

const Assessment = ({ id, created_at, token, state, scored, completed_at, completeSurvey=()=>{}}) => (
  <tr className="pairin-admin-user-assessment">
    <td>{ConvertedDate(created_at)}</td>
    <td>{ token }</td>
    <td>{state}</td>
    <td>{completed_at}</td>
    <td>{scored?<CheckedSvg />:''}</td>
    <td>
      {
        !scored
          ? <button onClick={()=>completeSurvey(id)}>Complete Survey</button>
          : null
      }
    </td>
  </tr>
);

class UserAssessmentsManager extends React.Component {
  mapAssessments = (assessment) => (
    <Assessment key={assessment.id} completeSurvey={this.completeSurvey} {...assessment} />
  )

  completeSurvey = async (id) => {
    if (await Confirm('Are you sure?')) {
      try {
        const { data } = await Query(`
          mutation {
            complete_and_score_assessment (id: ${id}) {
              success,
              errors
            }
          }
        `);

        if (resolve(data, 'complete_and_score_assessment/success', true)) {
          this.props.reload_graph(true, true);
        } else {
          for (const error of resolve(data, 'complete_and_score_assessment/errors', [])) {
            Notification.new(
              {timeout: 5000},
              <NotificationError>
                { error }
              </NotificationError>
            );
          }
        }
      } catch (e) {
        console.error(e);
        Notification.new(
          {timeout: 5000},
          <NotificationError>
            { e.toString() }
          </NotificationError>
        );
      }
    }
  }

  render() {
    const {
      graph_data,
      graph_loading,
      reload_graph
    } = this.props;

    if (graph_loading) {
      return <Loading />;
    }
    return (
      <div className="pairin-admin-user-body">
        <MemoryRouter>
          <Link to={`/survey-connector/${resolve(this.props, 'match/params/user', {} )}`}>Survey Connector</Link>
          <Switch>
            <Route path={`/survey-connector/:user_id`}>
              <SurveyConnector reload_graph={reload_graph} />
            </Route>
          </Switch>
        </MemoryRouter>
        <table className="pairin-admin-user-assessments">
          <tr>
            <th>Created At</th>
            <th>Survey Token</th>
            <th>State</th>
            <th>Completed At</th>
            <th>scored</th>
            <th></th>
          </tr>
          {
            !resolve(graph_data, 'user/assessments', []).length
              ? <h1> No Assessments </h1>
              : resolve(graph_data, 'user/assessments', []).map(this.mapAssessments)
          }
        </table>
      </div>
    );
  }
}


UserAssessmentsManager.parseQueryData = (data) => {
  data.user.assessments = resolve(data, 'user/assessments', []).sort((a,b)=>(
    (new Date(a.created_at)) - (new Date(b.created_at))
  ));
  return data;
};
UserAssessmentsManager.query = (token, { match }) => (
  Query(`{
    user (id: ${match.params.user}) {
      id,
      assessments(recent: false) {
        id
        token
        state
        created_at
        completed_at
        progress
        scored
        version
        validity_score
        validity_errors
      }
    }
  }`)
);

export default withRouter(withData(UserAssessmentsManager));
